var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Chart", {
        attrs: {
          "chart-style": _vm.chartStyle,
          data: _vm.data,
          "range-definition": "12hours",
          definition: _vm.setDefinitions,
          options: _vm.options
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }